<template>
  <b-form @submit.prevent="submitForm">
    <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
    <template v-if="!isLoading && currentLogPolicy">
      <b-form-group>
        <template v-slot:label>{{ $t("numberDaysKeepLog") }} <span class="text-danger">*</span></template>
        <b-form-input type="number" v-model="numberDaysKeepLog" name="numberDaysKeepLog" required min="30" max="3650"/>
      </b-form-group>

      <div class="text-right pt-3">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
      </div>
    </template>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as systemLogsService from "@/service/systemLogsService";

  @Component
  export default class LogPolicySettingsModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;

    isLoading = true;
    currentLogPolicy: null;

    numberDaysKeepLog = 1;

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {
      this.fetchCurrentPolicy();
    }

    async fetchCurrentPolicy() {
      try {
        this.isLoading = true;
        this.currentLogPolicy = await systemLogsService.getPolicy();
        Object.assign(this, this.currentLogPolicy);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";

      try {
        this.isSubmitting = true;
        await systemLogsService.setPolicy({
          numberDaysKeepLog: +this.numberDaysKeepLog
        });

        this.__submitted();
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$bvModal.hide(this.modalId);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
